<script>
        import * as animateScroll from "svelte-scrollto";
        import { onMount } from 'svelte';
        export let subSelection;
        export let selectedProyect;

        onMount(async () => {

            if (selectedProyect == null) {
                const proxyurl = "";
                const url = 'https://plataforma.cvschile.cl/site/project?id=' + window.location.hash.split('/')[2];

                try {
                    const response = await fetch(proxyurl + url);
                    selectedProyect = await response.json();
                    console.log(selectedProyect);
                } catch (error) {
                    console.log(error);
                }
            }

            if(subSelection == 0)  animateScroll.scrollToTop();
            else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
        });
</script>

{#if selectedProyect}
<div class="row">
    <div class="col-12 section-cvs" style="text-align: center;">
        <h1>Ficha</h1>
    </div>
    <div class="col-12" style="text-align: -webkit-center;">
        <div class="img-container">
            {#if selectedProyect}
                <img src={selectedProyect.image} alt="" class="file-img-size">
                <h3 class="proyect-name" >{selectedProyect.proyect}</h3>
            {:else} 
                <img src="./img/register/casa-sustentable-ejemplo.png" alt="" class="file-img-size">
                <h3 class="proyect-name" >PRÓXIMAMENTE</h3>
            {/if}

        </div>
    </div>
    <div class="col-12" style="margin-bottom:5vh;text-align: -webkit-center;">
        {#if selectedProyect}
            <div class="file-info-box">
                <p>Región: {selectedProyect.region}</p>
                <p>Comuna: {selectedProyect.commune}</p>
                <p>Ciudad: {selectedProyect.city}</p>
                <p>Dirección: {selectedProyect.address}</p>
                <p>Cantidad de viviendas: {selectedProyect.number_of_homes}</p>
                <p>Superficie construida: {selectedProyect.build_up_area}</p>
                <p>Superficie de terreno: {selectedProyect.land_area}</p>
                <p>Mandante: {selectedProyect.client}</p>
                <p>Arquitecto: {selectedProyect.architect}</p>
                <p>Constructora: {selectedProyect.construction_company}</p>
                <p>Asesor: {selectedProyect.adviser}</p>
                <p>Fecha de la certificación: <!-- (solo si está certificado)  -->{selectedProyect.certification_date}</p>
                <p>Financiamiento: <!--  (proyecto social o proyecto privado)  -->{selectedProyect.financing}</p>
            </div>
        {:else} 
        <div class="file-info-box">
            <p>Región: Próximamente</p>
            <p>Comuna: Próximamente</p>
            <p>Ciudad: Próximamente</p>
            <p>Dirección: Próximamente</p>
            <p>Cantidad de viviendas: Próximamente</p>
            <p>Superficie construida: Próximamente</p>
            <p>Superficie de terreno: Próximamente</p>
            <p>Mandante: Próximamente</p>
            <p>Arquitecto: Próximamente</p>
            <p>Constructora: Próximamente</p>
            <p>Asesor: Próximamente</p>
            <p>Fecha de la certificación: (solo si está certificado) Próximamente</p>
            <p>Financiamiento: (proyecto social o proyecto privado) Próximamente</p>
        </div>
        {/if}
    </div>
</div>
{:else}
    <div class="d-flex justify-content-center" style="margin-top: 25%;">
        <div class="spinner-border" role="status" style="height: 100px;width: 100px;">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
{/if}

<style>
.img-container{
    padding-top: 11px;
    height: 325px;
    width: 500px;
    background-color: #E5EAF7;
}
.proyect-name{
    font-family: 'DINPro-Regular' !important;
    font-size: 30pt;
    color: #006937;
    float: left;
    padding-left: 11px;
    margin-bottom: -6px;
}
.file-info-box{
    padding: 13px;
    width: 500px;
    max-width: 515px;
    background-color:  #F9FBF2;
    font-family: 'DINPro-Regular';
    font-size: 12pt;
    color: #006937;
    text-align: -webkit-left;
}

.file-img-size{
    width: 475px;
    height: 270px;
}

</style>
